import React, { Component } from 'react';
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import './HelpModal.scss';

interface HelpModalProps {
  currentUser?: any;
  className?: string;
  isOpen: boolean;
  onToggleModal?(): void;
}

interface HelpModalState {
  helpModal: boolean;
}

class HelpModal extends Component<HelpModalProps, HelpModalState> {
  constructor(props: HelpModalProps) {
    super(props);

    this.state = { helpModal: false };
  }

  toggleHelpModal = () => {
    this.setState({
      helpModal: !this.state.helpModal,
    });
  };

  render() {
    const { isOpen, onToggleModal } = this.props;

    let key = 'help';
    let modalTitle = 'Help';

    return (
      <div key={key}>
        <Modal
          isOpen={isOpen}
          toggle={onToggleModal}
          className={this.props.className}
          backdrop={'static'}
          keyboard={false}
        >
          <ModalHeader toggle={onToggleModal}>{modalTitle}</ModalHeader>
          <ModalBody>
            <Container>
              <div className="helpdocs">
                <p>
                  A Jookable jukebox plays YouTube videos on a TV, and anyone at the venue can add songs from their
                  phone or computer.
                </p>
                <h3>Adding songs</h3>
                <p>
                  Scan the QR code on the TV, or type the code shown at the top of the TV screen into the box on
                  your home screen and tap Go. Search for a song and tap Add to queue. Star songs to keep them in Favorites
                  for next time. Jukeboxes you have used show under Recent jukeboxes, and Find venues near you shows
                  bars and restaurants with Jookable on a map.
                </p>
                <h3>Bumps</h3>
                <p>
                  A bump moves one of your songs up one place in the queue. A super bump moves it to the front,
                  behind any other super bumped songs. Bumped songs have a silver border and super bumped songs a
                  gold one.
                </p>
                <h3>Trivia and shout-outs</h3>
                <p>
                  When the venue runs trivia, the jukebox page takes you to the game and you answer on your phone.
                  Where the venue allows it, you can pay to put a short shout-out on the TV.
                </p>
                <h3>Running a jukebox</h3>
                <p>
                  Tap Run Jookable at your venue (or New jukebox) on the home screen and give it a name. Under Your
                  jukeboxes, tap TV screen on the computer connected to the venue&apos;s TV, and Control panel on your
                  phone. The control panel skips and moves songs and switches the TV between the jukebox and trivia.
                  Its Settings tab has the name and ticker, song rules, your logo, shout-outs, the venues map, your
                  admins, and Reset and Delete.
                </p>
                <h3>Your profile</h3>
                <p>
                  Tap Profile to change your name and photo, which show beside the songs you add. You can also
                  change your password or delete your account there.
                </p>
              </div>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={onToggleModal}>
              {'Close'}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default HelpModal;
